import { useCallback, useEffect, useState } from "react";

interface ThumbnailCapableEntity {
  readonly url: string;
  readonly thumbnailUrl?: string;
}

/** Thumbnail source with a full-size fallback when there is none or it fails to load. */
export function useThumbnailImageSrc(data: ThumbnailCapableEntity | undefined): {
  readonly src: string | undefined;
  readonly onError: () => void;
} {
  const [thumbnailFailed, setThumbnailFailed] = useState(false);
  const thumbnailUrl = data?.thumbnailUrl;

  useEffect(() => {
    setThumbnailFailed(false);
  }, [thumbnailUrl]);

  const onError = useCallback(() => {
    setThumbnailFailed(true);
  }, []);

  return { src: thumbnailUrl === undefined || thumbnailFailed ? data?.url : thumbnailUrl, onError };
}
